import React from "react";
import { useTranslation } from "react-i18next";
import PathLink from "../../shared/seo/PathLink";
import "./lawyers.css";

// 1 … 4 5 [6] 7 8 … 20
function pageWindow(page, pages) {
  const shown = new Set([1, pages]);
  for (let p = page - 2; p <= page + 2; p++) if (p >= 1 && p <= pages) shown.add(p);
  const sorted = [...shown].sort((a, b) => a - b);
  const items = [];
  sorted.forEach((p, i) => {
    if (i > 0 && p - sorted[i - 1] > 1) items.push("gap-" + p);
    items.push(p);
  });
  return items;
}

/**
 * Numbered pages as real links, so crawlers can reach every lawyer.
 * pathFor(page) returns the decoded listing path of a page.
 */
export default function LawyersPagination({ page, pages, pathFor, state }) {
  const { t } = useTranslation();
  if (pages <= 1) return null;
  return (
    <nav className="avc-pagination" aria-label={t("pagination_label")}>
      <ul>
        {page > 1 && (
          <li>
            <PathLink to={pathFor(page - 1)} state={state} rel="prev" className="avc-pagination__step">
              {t("pagination_prev")}
            </PathLink>
          </li>
        )}
        {pageWindow(page, pages).map((p) =>
          typeof p === "string" ? (
            <li key={p} className="avc-pagination__gap" aria-hidden="true">
              …
            </li>
          ) : (
            <li key={p}>
              {p === page ? (
                <span className="avc-pagination__current" aria-current="page">
                  {p}
                </span>
              ) : (
                <PathLink to={pathFor(p)} state={state}>
                  {p}
                </PathLink>
              )}
            </li>
          )
        )}
        {page < pages && (
          <li>
            <PathLink to={pathFor(page + 1)} state={state} rel="next" className="avc-pagination__step">
              {t("pagination_next")}
            </PathLink>
          </li>
        )}
      </ul>
    </nav>
  );
}
